import { createNpcClient } from '@npc/api-client'

/**
 * 控制面 API 客户端。
 *
 * 类型全部来自 `openapi/openapi.yaml` 的生成物，**不手写任何接口定义**。
 * 契约变了就 `git pull && make generate-api`，编译期立刻能看出哪儿对不上。
 */
/**
 * 同源前缀。默认 `/api/v1`。
 *
 * 可以用 `VITE_API_BASE` 换成绝对地址，两处要用：
 *   - 手机壳与桌面壳（Capacitor / Tauri）里没有同源这回事
 *   - jsdom 里 `new URL('/api/v1/hosts')` 会抛错（它不认没有 base 的相对地址），
 *     所以 Vitest 那边把它设成了 `http://localhost/api/v1`
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? '/api/v1'

export const api = createNpcClient({
  baseUrl: API_BASE,
  // 每次请求都取「当下的」globalThis.fetch，而不是建客户端时那一个。
  // openapi-fetch 默认会把 fetch 存下来，那样一来「装 mock」与「建客户端」的先后顺序
  // 就成了隐形的坑（踩过：mock 装上了但请求照样打到代理上）。多这一层，顺序不再要紧。
  fetch: (request) => globalThis.fetch(request),
})
